import React, { useEffect } from 'react'
import type { FC } from 'react'
import { Helmet } from 'react-helmet'
import loadScript from '@/checkout-instore-legacy/utils/CustomScript'

import { sendEvent } from '../../utils/customEvent'
import { useLogRocket } from '../../hooks/useLogRocket'

declare global {
  interface Window {
    inStoreIsLoaded: boolean
  }
}

export const CustomScriptLoader: FC = () => {
  useEffect(() => {
    window.inStoreIsLoaded = true

    loadScript('/files/checkout-instore-custom.js', 4)

    sendEvent('load.instore')
  }, [])

  useLogRocket()

  return (
    <Helmet>
      <link
        href="/files/checkout-instore-custom.css"
        rel="stylesheet"
        type="text/css"
      />
    </Helmet>
  )
}
